import store from '@/store'
import axios from 'axios'

/**
* Creamos un subscribe para manipular las mutaciones
* en el momento que se realizan sobre nuestros estados
* @param  {mutation}
*/
store.subscribe( (mutation) => {
    // filtramos la mutacion por el tipo
    switch (mutation.type) {
        // si la mutacion es de tipo set_token, ejecutaremos estas instrucciones
        case 'auth/SET_TOKEN':
            // preguntamos si vamos a asignar el token, sino vamos a limpiarlo
            if (mutation.payload) {
                // lo agregamos a las cabeceras de axios de forma predeterminada
                axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
                // lo guardamos en el localstorage
                localStorage.setItem( 'token', mutation.payload )
            } else {
                // lo retiramos de las cabeceras de axios
                axios.defaults.headers.common['Authorization'] = null
                // lo eliminamos del localstorage
                localStorage.removeItem( 'token')
            }
            break
    }
})
